import React from 'react';
import useAudio from 'utils/hooks/useAudio';
import './AudioMessage.scss';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import IconButton from '@mui/material/IconButton';
import PauseIcon from '@mui/icons-material/Pause';

export default function AudioMessage(props) {
  const { fileUrl } = props;
  const [playing, toggle] = useAudio(fileUrl);
  return (
    <div className={'AudioOutgoingFileMessage'}>
      <IconButton onClick={toggle} size="small">
        {playing ? <PauseIcon /> : <PlayArrowIcon />}
      </IconButton>
      <span>Audio Message</span>
    </div>
  );
}
